export const encodeNodeId = <N>(
  id: string,
  entity: N,
  level: number,
  workspaceId: string
) => `${id}-${entity}-${level}-${workspaceId}`;

// TODO: add assertion that stringArray[1] is of type N, instead of assuming
export const parseNodeId = <N>(nodeId: string): [string, N, number, string] => {
  const stringArray = nodeId.split('-');
  return [
    stringArray[0],
    stringArray[1] as N,
    Number(stringArray[2]),
    stringArray[3],
  ];
};
